import { useCallback, useEffect, useState } from "react";

import { getDefaultClientNotes } from "@/mockData/ariPortfolio";
import { usePersistStore } from "@/hooks/common/usePersistStore";

const NOTES_STORAGE_KEY = "ari-portfolio-client-notes";

export function useAriClientNotes(clientId: string) {
  const { getLocal, putLocal } = usePersistStore();
  const [notes, setNotes] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    void (async () => {
      const stored = await getLocal<Record<string, string>>(NOTES_STORAGE_KEY);
      if (cancelled) return;
      setNotes(stored?.[clientId] ?? getDefaultClientNotes(clientId));
      setIsLoading(false);
    })();

    return () => {
      cancelled = true;
    };
  }, [clientId, getLocal]);

  const saveNotes = useCallback(
    async (value: string) => {
      setNotes(value);
      const stored = (await getLocal<Record<string, string>>(NOTES_STORAGE_KEY)) ?? {};
      await putLocal(NOTES_STORAGE_KEY, { ...stored, [clientId]: value }, true);
    },
    [clientId, getLocal, putLocal],
  );

  return { notes, saveNotes, isLoading };
}
